import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";

import Select from "react-select";
import withRouter from "../../../components/Common/withRouter";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link, useParams,useNavigate  } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import MediaModel from "../MediaUpload/MediaModel";
import toast from "react-hot-toast";
const EditProduct = () => {
  const baseurl = process.env.REACT_APP_BASE_URL;
  const imgurl = process.env.REACT_APP_IMAGE_URL;
  const { id } = useParams();
  const navigate = useNavigate();
  document.title = `Edit product - ${id} | Vekart`;
  const fileInputRef = useRef(null);

  const [shortContent, setShortContent] = useState("");
  const [longContent, setLongContent] = useState("");
  const [selectedFeatures, setSelectedFeatures] = useState([]);

  const [modalType, setModalType] = useState(null);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [imageModel, setImageModel] = useState(false);
  const [selectedImage, setSelectedImage] = useState([]);
  const [uploadedOtherImages, setUploadedOtherImages] = useState([]);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
  const [editData, setEditData] = useState(null);
  const [productsData, setproductsData] = useState(null);
    const [otherImages, setOtherImages] = useState([]);
    const [uploadedDataSheet, setUploadedDataSheet] = useState([]);
  
    const [brandData, setbrandData] = useState([]);
    const [certificateData, setcertificateData] = useState([]);
    const [selectedCertificates, setSelectedCertificates] = useState([]);
    const [displayData, setdisplayData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [subCategoryData, setSubCategoryData] = useState([]);
    const [subSubCategoryData, setSubSubCategoryData] = useState([]);
  
    const [filteredCategoryData, setFilteredCategoryData] = useState([]);
    const [filteredSubCategoryData, setFilteredSubCategoryData] = useState([]);
    const [error, setError] = useState(null);

 const viewData = productsData;
    const productsDatas = async () => {
        try {
          setError(null); // Reset error before fetching
          const response = await fetch(`${baseurl}/admin/products/products/`+id);
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();
          setproductsData(data);
        } catch (error) {
          setError(error.message);
        }
      }; 

const BrandData = async () => {
        try {
          setError(null); // Reset error before fetching
          const response = await fetch(`${baseurl}/admin/master/active-brands`);
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();
          setbrandData(data);
        } catch (error) {
          setError(error.message);
        }
      }; 

      const CertificateData = async () => {
        try {
          setError(null); // Reset error before fetching
          const response = await fetch(`${baseurl}/admin/master/active-certificates`);
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();
          setcertificateData(data);
        } catch (error) {
          setError(error.message);
        }
      }; 



  const DisplayNameData = async () => {
        try {
          setError(null); // Reset error before fetching
          const response = await fetch(`${baseurl}/admin/master/active-displaynames`);
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();
          setdisplayData(data);
        } catch (error) {
          setError(error.message);
        }
      }; 
  const fetchCategoryData = async () => {
        try {
          setError(null); // Reset error before fetching
          const response = await fetch(`${baseurl}/admin/master/active-categories`);
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();
          setCategoryData(data);
        } catch (error) {
          setError(error.message);
        }
      };

      const fetchSubCategoryData = async () => {
      try {
        setError(null); // Reset error before fetching
        const response = await fetch(`${baseurl}/admin/master/active-subcategories`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setSubCategoryData(data);
      } catch (error) {
        setError(error.message);
      }
    };

    const fetchSubSubCategoryData = async (sub_category) => {
      try {
        setError(null); // Reset error before fetching
        const response = await fetch(`${baseurl}/admin/master/active-subsubcategories-by-id/${sub_category}`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setSubSubCategoryData(data);
      } catch (error) {
        setError(error.message);
      }
    };

    const fetchFeature = async (viewData) => {
    try {
      const response = await fetch(`${baseurl}/admin/master/active-feature-by-id/${viewData?.sub_sub_category}`);
      const data = await response.json();
      
      const mergedFeatures = data.map(feature => {
      const existing = viewData?.features?.find(f => f.fid === feature.id);
      return {
        ...feature,
        value: existing?.value || ''  // retain value if found
      };
    });
console.log("Fetched features:", mergedFeatures);
      setSelectedFeatures(mergedFeatures);
      formik.setFieldValue('features', mergedFeatures);

    } catch (error) {
      console.error("Error fetching features:", error);
    }
  };

    
    
      useEffect(() => {
        productsDatas();
        BrandData();
        CertificateData();
        DisplayNameData();
        fetchCategoryData();
        fetchSubCategoryData();
        
      }, []);
  
 

  useEffect(() => {
  if (viewData) {
    setEditData(viewData);

    setUploadedImages(
      viewData?.feature_image ? [viewData.feature_image] : []
    );

    setUploadedOtherImages(viewData?.other_images || []);

    setUploadedDataSheet(
      viewData?.datasheet ? [viewData.datasheet] : []
    );

    setPdfPreviewUrl(
      viewData?.datasheet?.fileurl
        ? imgurl + viewData.datasheet.fileurl
        : null
    );

    setShortContent(viewData?.shortDescription);
    setLongContent(viewData?.longDescription);

    fetchSubSubCategoryData(viewData?.sub_category);
    fetchFeature(viewData);
  }
}, [viewData]);

  const handleDisplayNameChange = async (e) => {
  const dnid = e.target.value;
  formik.setFieldValue("displayName", dnid);
  formik.setFieldValue("categoryName", "");
  formik.setFieldValue("subCategoryName", "");
  formik.setFieldValue("subSubCategoryName", "");

  const filteredCategories = categoryData.filter(
    (cat) => String(cat.dnid) === String(dnid)
  );
  setFilteredCategoryData(filteredCategories);
  setFilteredSubCategoryData([]);
  setSubSubCategoryData([]);
};

const handleCategoryChange = (e) => {
  const cid = e.target.value;
  formik.setFieldValue("categoryName", cid);
  formik.setFieldValue("subCategoryName", "");
  formik.setFieldValue("subSubCategoryName", "");

  const filteredSubCategories = subCategoryData.filter(
    (sub) => String(sub.cid) === String(cid)
  );
  setFilteredSubCategoryData(filteredSubCategories);
  setSubSubCategoryData([]);
};


const handleSubCategoryChange = async (e) => {
  const subCategoryId = e.target.value;
  formik.setFieldValue("subCategoryName", subCategoryId);
  formik.setFieldValue("subSubCategoryName", "");

  try {
    const response = await fetch(`${baseurl}/admin/master/active-subsubcategories-by-id/${subCategoryId}`);
    const data = await response.json();
    console.log("Fetched sub-subcategories:", data);
    setSubSubCategoryData(data);
  } catch (error) {
    console.error("Error fetching sub-sub-categories:", error);
  }
};

const handleSubSubCategoryChange = async (e) => {
    const subsubCategoryId = e.target.value;
    formik.setFieldValue("subSubCategoryName", subsubCategoryId);
console.log("Fetched features:", subsubCategoryId);
    try {
      const response = await fetch(`${baseurl}/admin/master/active-feature-by-id/${subsubCategoryId}`);
      const data = await response.json();
      console.log("Fetched features:", data);
      setSelectedFeatures(data);
      const features = data.map((feature) => ({
      id: feature.id,
      value: ""
    }));
    formik.setFieldValue("features", features);
    } catch (error) {
      console.error("Error fetching features:", error);
    }
  };
  

  const options = certificateData?.map((data) => ({
    value: data?.id,
    label: data?.certificate_name,
  })) || [];

  const selectedCertificatess = options.filter(opt =>
  editData?.certificate?.includes(opt.value)
);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      productCode: id,
      productName: editData?.product_name || '',
      displayName: editData?.display_name || '',
      productDesc: editData?.product_desc || '',
      productSdesc: editData?.product_sdesc || '',
      categoryName: editData?.category || '',
      subCategoryName: editData?.sub_category || '',
      subSubCategoryName: editData?.sub_sub_category || '',
      brandName: editData?.brand || '',
      certificate:selectedCertificatess || [],
      manufacturePartNumber: editData?.manufacturer_part_no || '',
      minimumStockQuantityWarning: editData?.min_stock_warning || '',
      mrp: editData?.mrp || '',
      remark:editData?.remark || '',
      weight_kg: editData?.weight_kg || '',
      standard_lead_time: editData?.standard_lead_time || '',
      hsncode: editData?.hsncode || '',
      reservedQuantity: editData?.reserved_quantity || 0,
      CGST: editData?.cgst_pr || '',
      SGST: editData?.sgst_pr || '',
      IGST: editData?.igst_pr || '',
      status: editData?.status || '',
      visibility: editData?.visibility || '',
      images: uploadedImages || null,
      otherImages: uploadedOtherImages || [],
      technicalDataSheets: uploadedDataSheet || null,
      features: editData?.features?.map(f => ({
      id: f.fid,
      value: f.value || "",
    })) || [],
      outOfStock: editData?.purchase_price || '',
      margin: editData?.margin_pr || '',
      loading: editData?.loading_pr || '',
      metaTitle: editData?.meta_title || '',
      metaDescription: editData?.meta_description || '',
      metaKeywords: editData?.meta_keywords || '',
    },
    validationSchema: Yup.object({
      productCode: Yup.string().required("Please enter the product code"),
      productName: Yup.string().required("Please enter the product name"),
      displayName: Yup.string().required("Please select a display name"),
      categoryName: Yup.string().required("Please select a category"),
      subCategoryName: Yup.string().required("Please select a sub-category"),
      subSubCategoryName: Yup.string().required(
        "Please select a sub-sub category"
      ),
      brandName: Yup.string().required("Please select a brand"),
      manufacturePartNumber: Yup.string().required(
        "Please enter the manufacturer part number"
      ),
      minimumStockQuantityWarning: Yup.number()
        .required("Please enter the minimum stock quantity warning")
        .positive("Must be a positive number"),
      mrp: Yup.number()
        .required("Please enter the MRP")
        .positive("Must be a positive number"),
      weight_kg: Yup
    .number()
    .typeError("Please enter a valid number")       // ensures number
    .required("Please enter the weight kg")
    .positive("Weight must be a positive number")    // if you expect > 0
    .test(
      'max-decimals',
      'Weight can have up to 2 decimal places',
      value => {
        if (value == null) return true;             // required() handles null/undefined
        return /^\d+(\.\d{1,2})?$/.test(value.toString());
      }
    ),
      hsncode: Yup.string()
              .required("Please enter the hsn code"),
      reservedQuantity: Yup.number()
        .required("Please enter the reserved quantity")
        .positive("Must be a positive number")
        .min(0),
      CGST: Yup.number()
        .required("Please enter the CGST percentage")
        .positive("Must be a positive number")
        .min(0, "CGST must be at least 0%")
        .max(100, "CGST cannot exceed 100%"),
      SGST: Yup.number()
        .required("Please enter the SGST percentage")
        .positive("Must be a positive number")
        .min(0, "SGST must be at least 0%")
        .max(100, "SGST cannot exceed 100%"),
      IGST: Yup.number()
        .required("Please enter the IGST percentage")
        .positive("Must be a positive number")
        .min(0, "IGST must be at least 0%")
        .max(100, "IGST cannot exceed 100%"),
      visibility: Yup.string().required("Please select the visibility"),
      status: Yup.string().required("Please select the status"),
      outOfStock: Yup.string().required("Please enter purchase Price"),
      loading: Yup.number()
        .required("Please enter loading percentage")
        .positive("Must be a positive number")
        .min(0, "loading must be at least 0%")
        .max(100, "loading cannot exceed 100%"),
      margin: Yup.number()
        .required("Please enter margin percentage")
        .positive("Must be a positive number")
        .min(0, "margin must be at least 0%")
        .max(100, "margin cannot exceed 100%"),
      images: Yup.array()
        .min(1, "Please upload an image")
        .max(1, "You can only upload 1 image"),
      otherImages: Yup.array()
        .min(1, "Please upload an image")
        .max(5, "You can upload maximum 5 images"),
      technicalDataSheets: Yup.array()
        .min(1, "Please upload a datasheet")
        .required("Datasheet is required"),
        features: Yup.array().of(
                Yup.object().shape({
                  id: Yup.number().required(),
                  value: Yup.string().required('This field is required')
                })
              ),
      metaTitle: Yup.string().required("Meta title is required"),
      metaDescription: Yup.string()
        .required("Meta description is required")
        .max(180, "Meta description cannot exceed 180 characters"),
      metaKeywords: Yup.string().required("Meta keywords are required"),
    }),
    onSubmit: async (values) => {
      const { productCode,productName,productDesc,productSdesc,certificate,displayName,categoryName,subCategoryName,subSubCategoryName,
        brandName,manufacturePartNumber,minimumStockQuantityWarning,mrp,weight_kg,standard_lead_time,hsncode,reservedQuantity,CGST,
        SGST,IGST,status,visibility,outOfStock,loading,margin,technicalDataSheets,images,otherImages,features,
        metaTitle,metaDescription,metaKeywords,remark } = values;
        
            try {
              let response;
              const cleanFeatures = features.map(f => ({
      id: f.id,
      value: f.value
    }));
                // For add, make an API POST request
                response = await fetch(baseurl+'/admin/products/products/'+editData?.id, {
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    product_name: productName, 
                    product_desc: productDesc, 
                    product_sdesc: productSdesc,
                    product_code: productCode,
                    certificate: certificate,
                    display_name: displayName,
                    category: categoryName,
                    sub_category: subCategoryName, 
                    sub_sub_category: subSubCategoryName,
                    manufacturer_part_no: manufacturePartNumber,
                    min_stock_warning: minimumStockQuantityWarning,
                    mrp: mrp,
                     weight_kg: weight_kg,
                     standard_lead_time:standard_lead_time,
                      hsncode: hsncode,
                    reserved_quantity: reservedQuantity,
                    cgst_pr: CGST,
                    sgst_pr: SGST,
                    igst_pr: IGST,
                    purchase_price: outOfStock,
                    loading_pr: loading,
                    margin_pr: margin,
                    remark:remark,
                    status: status,
                    visibility: visibility, 
                    brand: brandName,
                    feature_image: images,
                    other_images: otherImages,
                    features:cleanFeatures,
                    meta_title: metaTitle,
                    meta_description: metaDescription, 
                    meta_keywords: metaKeywords, 
                    datasheet: technicalDataSheets,
                  }),
                });
               if (!response.ok) {
                  throw new Error("Error adding new user");
                }
                toast.success('Product update successfully!', 'success');
                
              // Close modal or do further actions
              //toggleModal();
              setUploadedImages([]);
              setUploadedOtherImages([]);
              setUploadedDataSheet([]);
              formik.resetForm();
              navigate("/manage-products");
            } catch (error) {
              console.error(error);
              // Handle any errors, show an error message if needed
            }
    },
  });

  

  
  const handleShortContentChange = (newContent) => {
    setShortContent(newContent);
    formik.setFieldValue("productSdesc", newContent);
    // console.log("setShortContent", newContent);
  };

  const handleLongContentChange = (newContent) => {
    setLongContent(newContent);
    formik.setFieldValue("productDesc", newContent);
    // console.log("setLongContent", newContent);
  };



  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const newImage = Object.assign(file, {
        preview: URL.createObjectURL(file),
      });
      formik.setFieldValue("images", [newImage]);
    }
  };

  const handleOtherImageChange = (event) => {
    const files = Array.from(event.target.files).map((file) =>
      Object.assign(file, { preview: URL.createObjectURL(file) })
    );
    const updated = [...(formik.values.otherImages || []), ...files];
    formik.setFieldValue("otherImages", updated);
  };

  const toggleModal = (type = null) => {
    setImageModel(!imageModel);
    setSelectedImage([]);
    setModalType(type);
  };

  const handleUploadImage = (images) => {
    if (modalType === "feature") {
      setUploadedImages([images[0]]);
      console.log([images[0].image]);
    } else if (modalType === "other") {
      setUploadedOtherImages((prev) => {
        const newImages = images.map((img) => img);

        if (prev.length + newImages.length > 5) {
          return [...prev.slice(newImages.length), ...newImages];
        }
        return [...prev, ...newImages];
      });
    } else if (modalType === "datasheet") {
       setPdfPreviewUrl([imgurl + images[0].fileurl]);
      setUploadedDataSheet([images[0]]);
    }

    setImageModel(false);
    setSelectedImage([]);
    setModalType(null);
  };

  const handleDataSheetChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileType = file.type;
      if (fileType === "application/pdf") {
        setUploadedDataSheet([file]);
        setPdfPreviewUrl(URL.createObjectURL(file));
      } else {
        alert("Only PDF files are allowed.");
      }
    }
  };

  const handleRemovePdf = () => {
    setPdfPreviewUrl(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      [{ align: [] }],
      [{ color: [] }],
      ["code-block"],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  const quillFormats = [
    "header",
    "bold",
    "italic",
    "video",
    "font",
    "size",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "align",
    "color",
    "code-block",
  ];

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Product"
            breadcrumbItem={`Edit product - ${id}`}
          />
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-9 col-12">
                <div className="card" style={{ border: "1px solid #e9ebec" }}>
                  <div className="card-header">
                    <div className="flex-grow-1">
                      <h5 className="card-title mb-1">Product Information</h5>
                      <p className="text-muted mb-0">Fill all information below.</p>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                      <label className="form-label" for="product-title-input">
                        Product name
                      </label>
                      <Input
                        name="productName"
                        type="text"
                        placeholder="Insert product name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.productName}
                        invalid={
                          formik.touched.productName &&
                          formik.errors.productName
                            ? true
                            : false
                        }
                      />
                      {formik.touched.productName &&
                      formik.errors.productName ? (
                        <FormFeedback type="invalid">
                          {formik.errors.productName}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-5">
                      <label className="form-label">Product description</label>
                      <ReactQuill
                        value={formik.values.productDesc}
                        theme="snow"
                        onChange={handleLongContentChange}
                        modules={quillModules}
                        formats={quillFormats}
                        style={{ height: "280px" }}
                        placeholder="Enter your content...."
                        className=""
                      />
                    </div>
                  </div>
                </div>
                <div className="card" style={{ border: "1px solid #e9ebec" }}>
                  <div className="card-header">
                    <div className="flex-grow-1">
                      <h5 className="card-title mb-1">General Information</h5>
                      <p className="text-muted mb-0">Fill all information below.</p>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <Label className="form-label">Product Code</Label>
                        <Input
                          name="productCode"
                          type="text"
                          placeholder="Insert Product Code"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.productCode}
                          invalid={
                            formik.touched.productCode &&
                            formik.errors.productCode
                              ? true
                              : false
                          }
                          disabled
                        />
                        {formik.touched.productCode &&
                        formik.errors.productCode ? (
                          <FormFeedback type="invalid">
                            {formik.errors.productCode}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="col-md-4 mb-3">
                        <Label className="form-label">Select Certificate</Label>
                        <Select
                        name="certificate"
                          classNamePrefix="select2-selection"
                          placeholder="Choose Certificate"
                          options={options}
                          isMulti
                          value={formik.values.certificate || []}
                          onChange={(selected) => formik.setFieldValue('certificate', selected)}
                          onBlur={() => formik.setFieldTouched('certificate', true)}
                          className={
                            formik.touched.certificate && formik.errors.certificate
                              ? "is-invalid"
                              : ""
                          }
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <Label className="form-label">
                          Select Display Name
                        </Label>
                        <Input
                          name="displayName"
                          type="select"
                          onChange={handleDisplayNameChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.displayName}
                          invalid={
                            formik.touched.displayName &&
                            formik.errors.displayName
                              ? true
                              : false
                          }
                        >
                          <option value="" label="Select display name" />
                          {displayData.map((data) => (
                            <option key={data.id} value={data.id}>
                              {data.displayname}
                            </option>
                          ))}
                        </Input>
                        {formik.touched.displayName &&
                        formik.errors.displayName ? (
                          <FormFeedback type="invalid">
                            {formik.errors.displayName}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="col-md-4 mb-3">
                        <Label className="form-label">Select Category</Label>
                        <Input
                          name="categoryName"
                          type="select"
                          onChange={handleCategoryChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.categoryName}
                          invalid={
                            formik.touched.categoryName &&
                            formik.errors.categoryName
                              ? true
                              : false
                          }
                        >
                          <option value="" label="Select category" />
                          {categoryData.map((data) => (
                            <option key={data.id} value={data.id}>
                              {data.categoryname}
                            </option>
                          ))}
                        </Input>
                        {formik.touched.categoryName &&
                        formik.errors.categoryName ? (
                          <FormFeedback type="invalid">
                            {formik.errors.categoryName}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="col-md-4 mb-3">
                        <Label className="form-label">
                          Select Sub-Category
                        </Label>
                        <Input
                          name="subCategoryName"
                          type="select"
                          onChange={handleSubCategoryChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.subCategoryName}
                          invalid={
                            formik.touched.subCategoryName &&
                            formik.errors.subCategoryName
                              ? true
                              : false
                          }
                        >
                          <option value="" label="Select sub-category" />
                          {subCategoryData.map((data) => (
                            <option
                              key={data.id}
                              value={data.id}
                            >
                              {data.subcategoryname}
                            </option>
                          ))}
                        </Input>
                        {formik.touched.subCategoryName &&
                        formik.errors.subCategoryName ? (
                          <FormFeedback type="invalid">
                            {formik.errors.subCategoryName}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="col-md-4 mb-3">
                        <Label className="form-label">
                          Select Sub-sub Category
                        </Label>
                        <Input
                          name="subSubCategoryName"
                          type="select"
                          onChange={handleSubSubCategoryChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.subSubCategoryName}
                          invalid={
                            formik.touched.subSubCategoryName &&
                            formik.errors.subSubCategoryName
                              ? true
                              : false
                          }
                        >
                          <option value="" label="Select sub-sub category" />
                          {subSubCategoryData.map((data) => (
                            <option key={data.id} value={data.id}>
                              {data.subsub_categoryname}
                            </option>
                          ))}
                        </Input>
                        {formik.touched.subSubCategoryName &&
                        formik.errors.subSubCategoryName ? (
                          <FormFeedback type="invalid">
                            {formik.errors.subSubCategoryName}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="col-md-4 mb-3">
                        <Label className="form-label">
                          Manufacturer Part No.
                        </Label>
                        <Input
                          name="manufacturePartNumber"
                          type="text"
                          placeholder="Insert Manufacturer Part No."
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.manufacturePartNumber}
                          invalid={
                            formik.touched.manufacturePartNumber &&
                            formik.errors.manufacturePartNumber
                              ? true
                              : false
                          }
                        />
                        {formik.touched.manufacturePartNumber &&
                        formik.errors.manufacturePartNumber ? (
                          <FormFeedback type="invalid">
                            {formik.errors.manufacturePartNumber}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="col-md-4 mb-3">
                        <Label className="form-label">
                          Minimum Stock Qty. Warning
                        </Label>
                        <Input
                          name="minimumStockQuantityWarning"
                          type="number"
                          placeholder="Insert Minimum Stock Warning"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.minimumStockQuantityWarning}
                          invalid={
                            formik.touched.minimumStockQuantityWarning &&
                            formik.errors.minimumStockQuantityWarning
                              ? true
                              : false
                          }
                        />
                        {formik.touched.minimumStockQuantityWarning &&
                        formik.errors.minimumStockQuantityWarning ? (
                          <FormFeedback type="invalid">
                            {formik.errors.minimumStockQuantityWarning}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="col-md-4 mb-3">
                        <Label className="form-label">MRP (Per Item)</Label>
                        <Input
                          name="mrp"
                          type="number"
                          placeholder="Insert MRP"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.mrp}
                          invalid={
                            formik.touched.mrp && formik.errors.mrp
                              ? true
                              : false
                          }
                        />
                        {formik.touched.mrp && formik.errors.mrp ? (
                          <FormFeedback type="invalid">
                            {formik.errors.mrp}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="col-md-4 mb-3">
                                              <Label className="form-label">Weight (kg)</Label>
                                              <Input
                                                name="weight_kg"
                                                type="number"
                                                placeholder="Insert weight in kg"
                                                step= "0.01"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.weight_kg}
                                                invalid={
                                                  formik.touched.weight_kg && formik.errors.weight_kg
                                                    ? true
                                                    : false
                                                }
                                              />
                                              {formik.touched.weight_kg && formik.errors.weight_kg ? (
                                                <FormFeedback type="invalid">
                                                  {formik.errors.weight_kg}
                                                </FormFeedback>
                                              ) : null}
                                            </div>

                                            <div className="col-md-4 mb-3">
                                              <Label className="form-label">Standard lead time</Label>
                                              <Input
                                                name="standard_lead_time"
                                                type="text"
                                                placeholder="Insert standard lead time"
                                                
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.standard_lead_time}
                                                invalid={
                                                  formik.touched.standard_lead_time && formik.errors.standard_lead_time
                                                    ? true
                                                    : false
                                                }
                                              />
                                              {formik.touched.standard_lead_time && formik.errors.standard_lead_time ? (
                                                <FormFeedback type="invalid">
                                                  {formik.errors.standard_lead_time}
                                                </FormFeedback>
                                              ) : null}
                                            </div>
                      
                                            <div className="col-md-4 mb-3">
                                              <Label className="form-label">HSN Code</Label>
                                              <Input
                                                name="hsncode"
                                                type="text"
                                                placeholder="Insert hsncode"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.hsncode}
                                                invalid={
                                                  formik.touched.hsncode && formik.errors.hsncode
                                                    ? true
                                                    : false
                                                }
                                              />
                                              {formik.touched.hsncode && formik.errors.hsncode ? (
                                                <FormFeedback type="invalid">
                                                  {formik.errors.hsncode}
                                                </FormFeedback>
                                              ) : null}
                                            </div>
                      <div className="col-md-4 mb-3">
                        <Label className="form-label">Reserved Quantity</Label>
                        <Input
                          name="reservedQuantity"
                          type="number"
                          placeholder="Insert reserved quantity"
                          disabled
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.reservedQuantity}
                          invalid={
                            formik.touched.reservedQuantity &&
                            formik.errors.reservedQuantity
                              ? true
                              : false
                          }
                        />
                        {formik.touched.reservedQuantity &&
                        formik.errors.reservedQuantity ? (
                          <FormFeedback type="invalid">
                            {formik.errors.reservedQuantity}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="col-md-4 mb-3">
                        <Label className="form-label" htmlFor="CGST">
                          CGST Percentage (%)
                        </Label>
                        <Input
                          id="CGST"
                          name="CGST"
                          type="number"
                          placeholder="Enter CGST percentage (0-100%)"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.CGST}
                          invalid={
                            formik.touched.CGST && formik.errors.CGST
                              ? true
                              : false
                          }
                        />
                        {formik.touched.CGST && formik.errors.CGST ? (
                          <FormFeedback type="invalid">
                            {formik.errors.CGST}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="col-md-4 mb-3">
                        <Label className="form-label" htmlFor="SGST">
                          SGST Percentage (%)
                        </Label>
                        <Input
                          id="SGST"
                          name="SGST"
                          type="number"
                          placeholder="Enter SGST percentage (0-100%)"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.SGST}
                          invalid={
                            formik.touched.SGST && formik.errors.SGST
                              ? true
                              : false
                          }
                        />
                        {formik.touched.SGST && formik.errors.SGST ? (
                          <FormFeedback type="invalid">
                            {formik.errors.SGST}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="col-md-4 mb-3">
                        <Label className="form-label" htmlFor="IGST">
                          IGST Percentage (%)
                        </Label>
                        <Input
                          id="IGST"
                          name="IGST"
                          type="number"
                          placeholder="Enter IGST percentage (0-100%)"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.IGST}
                          invalid={
                            formik.touched.IGST && formik.errors.IGST
                              ? true
                              : false
                          }
                        />
                        {formik.touched.IGST && formik.errors.IGST ? (
                          <FormFeedback type="invalid">
                            {formik.errors.IGST}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="col-md-4 mb-3">
                        <Label className="form-label" htmlFor="outOfStock">
                          Purchase Price
                        </Label>
                        <Input
                          id="outOfStock"
                          name="outOfStock"
                          type="text"
                          placeholder="enter purchase Price"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.outOfStock}
                          invalid={
                            formik.touched.outOfStock &&
                            formik.errors.outOfStock
                              ? true
                              : false
                          }
                        />
                        {formik.touched.outOfStock &&
                        formik.errors.outOfStock ? (
                          <FormFeedback type="invalid">
                            {formik.errors.outOfStock}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="col-md-4 mb-3">
                        <Label className="form-label" htmlFor="loading">
                          Loading (%)
                        </Label>
                        <Input
                          id="loading"
                          name="loading"
                          type="number"
                          placeholder="Enter out of stock status"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.loading}
                          invalid={
                            formik.touched.loading && formik.errors.loading
                              ? true
                              : false
                          }
                        />
                        {formik.touched.loading && formik.errors.loading ? (
                          <FormFeedback type="invalid">
                            {formik.errors.loading}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="col-md-4 mb-3">
                        <Label className="form-label" htmlFor="margin">
                          Margin (%)
                        </Label>
                        <Input
                          id="margin"
                          name="margin"
                          type="number"
                          placeholder="Enter margin"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.margin}
                          invalid={
                            formik.touched.margin && formik.errors.margin
                              ? true
                              : false
                          }
                        />
                        {formik.touched.margin && formik.errors.margin ? (
                          <FormFeedback type="invalid">
                            {formik.errors.margin}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="col-md-8 mb-3">
                                              <Label className="form-label" htmlFor="remark">
                                                Remark
                                              </Label>
                                              <Input
                                                id="remark"
                                                name="remark"
                                                type="text"
                                                placeholder="Enter remark"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.remark}
                                                invalid={
                                                  formik.touched.remark && formik.errors.remark
                                                    ? true
                                                    : false
                                                }
                                              />
                                              {formik.touched.remark && formik.errors.remark ? (
                                                <FormFeedback type="invalid">
                                                  {formik.errors.remark}
                                                </FormFeedback>
                                              ) : null}
                                            </div>
                    </div>
                  </div>
                </div>

                {/* MRP Calculation Card */}
                <div className="card" style={{ border: "1px solid #e9ebec" }}>
                  <div className="card-header">
                    <div className="flex-grow-1">
                      <h5 className="card-title mb-1">MRP Calculation</h5>
                    </div>
                  </div>
                
                  <div className="card-body">
                    {(() => {
                     const basePrice = Number(formik.values.outOfStock || 0);
const marginPercent = Number(formik.values.margin || 0);
const loadingPercent = Number(formik.values.loading || 0);

const totalPercent = marginPercent + loadingPercent;

// Final MRP (correct)
const finalMRP = basePrice / (1 - (totalPercent / 100));

// Total profit
const totalProfit = finalMRP - basePrice;

// Split proportionally
const marginAmount = totalProfit * (marginPercent / totalPercent);
const loadingAmount = totalProfit * (loadingPercent / totalPercent);
                      return (
                        <div className="row">
                          <div className="col-md-3 mb-0">
                            <Label className="form-label" htmlFor="margin">Base Price</Label>
                            <p>₹{basePrice.toFixed(2)}</p>
                          </div>
                          <div className="col-md-3 mb-0">
                              <Label className="form-label" htmlFor="margin">Margin ({marginPercent}%)</Label>
                              <p>₹{marginAmount.toFixed(2)}</p>
                          </div>
                          <div className="col-md-3 mb-0">
                            <Label className="form-label" htmlFor="margin">Loading ({loadingPercent}%)</Label>
                              <p>₹{loadingAmount.toFixed(2)}</p>
                          
                          </div>
                          <div className="col-md-3 mb-0">
                            <Label className="form-label" htmlFor="margin">Final MRP</Label>
                              <p className="text-success">₹{finalMRP.toFixed(2)}</p>
                         
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                </div>

                 {selectedFeatures.length > 0 && (
                                  <>
                                    <div
                                      className="card"
                                      style={{ border: "1px solid #e9ebec" }}
                                    >
                                      <div className="card-header">
                                        <div className="flex-grow-1">
                                          <h5 className="card-title mb-1">Feature List</h5>
                                        </div>
                                      </div>
                                      <table className="table table-bordered">
                                        <thead>
                                          <tr>
                                            <th>Feature Name</th>
                                            <th>Add specification about the product</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {selectedFeatures?.map((feature, index) => (
                                            <tr key={index}>
                                              <td>{feature?.featurename}</td>
                                              <td>
                                              <input
                                                type="hidden"
                                                name={`features[${index}].id`}
                                                value={feature.id}
                                              />
                
                                                <Input
                                                  type="text"
                                                   name={`features[${index}].value`}
        value={formik.values.features[index].value}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
                                                ></Input>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  </>
                                )}
                {/* For Add Product Description Row */}
                <div className="card" style={{ border: "1px solid #e9ebec" }}>
                  <div className="card-header">
                    <div className="flex-grow-1">
                      <h5 className="card-title mb-1">Product Short Description</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="mb-5">
                      <ReactQuill
                        value={formik.values.productSdesc}
                        theme="snow"
                        onChange={handleShortContentChange}
                        modules={quillModules}
                        formats={quillFormats}
                        style={{ height: "300px" }}
                        placeholder="Enter your content...."
                        className=""
                      />
                    </div>
                  </div>
                </div>

                {/* For Add Product Meta Data Row */}
                <div className="card" style={{ border: "1px solid #e9ebec" }}>
                  <div className="card-header">
                    <div className="flex-grow-1">
                      <h5 className="card-title mb-1">Meta Data</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    <Row>
                      <Col sm={6}>
                        <div className="mb-3">
                          <Label className="form-label">Meta title</Label>
                          <Input
                            name="metaTitle"
                            type="text"
                            placeholder="Meta title"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.metaTitle || ""}
                            invalid={
                              formik.touched.metaTitle &&
                              formik.errors.metaTitle
                                ? true
                                : false
                            }
                          />
                          {formik.touched.metaTitle &&
                          formik.errors.metaTitle ? (
                            <FormFeedback type="invalid">
                              {formik.errors.metaTitle}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Meta Keywords</Label>
                          <Input
                            name="metaKeywords"
                            type="text"
                            placeholder="Meta Keywords"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.metaKeywords || ""}
                            invalid={
                              formik.touched.metaKeywords &&
                              formik.errors.metaKeywords
                                ? true
                                : false
                            }
                          />
                          {formik.touched.metaKeywords &&
                          formik.errors.metaKeywords ? (
                            <FormFeedback type="invalid">
                              {formik.errors.metaKeywords}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col sm={6}>
                        <Label className="form-label">
                          Meta Description (Max 180 Characters)
                        </Label>
                        <textarea
                          name="metaDescription"
                          placeholder="Enter Meta Description"
                          className="form-control"
                          rows="5"
                          maxLength="180"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.metaDescription}
                        />
                        <div className="small text-muted">
                          {formik.values.metaDescription.length}/180 characters
                        </div>
                        {formik.touched.metaDescription &&
                        formik.errors.metaDescription ? (
                          <div className="text-danger">
                            {formik.errors.metaDescription}
                          </div>
                        ) : null}
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-12">
                <div className="card" style={{ border: "1px solid #e9ebec" }}>
                  <div className="card-header">
                    <h5 className="card-title">Publish</h5>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                      <Label className="form-label">Status</Label>
                      <Input
                        name="status"
                        type="select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.status}
                        invalid={
                          formik.touched.status && formik.errors.status
                            ? true
                            : false
                        }
                      >
                        <option value="">Select Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </Input>
                      {formik.touched.status && formik.errors.status ? (
                        <FormFeedback type="invalid">
                          {formik.errors.status}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div>
                      <Label className="form-label">Visibility</Label>
                      <Input
                        name="visibility"
                        type="select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.visibility}
                        invalid={
                          formik.touched.visibility && formik.errors.visibility
                            ? true
                            : false
                        }
                      >
                        <option value="">Select Visibility</option>
                        <option value="Hidden">Hidden</option>
                        <option value="Public">Public</option>
                      </Input>
                      {formik.touched.visibility && formik.errors.visibility ? (
                        <FormFeedback type="invalid">
                          {formik.errors.visibility}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="card" style={{ border: "1px solid #e9ebec" }}>
                  <div className="card-header">
                    <h5 className="card-title">Product Brand</h5>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                      <Label className="form-label">Select Brand</Label>
                      <Input
                        name="brandName"
                        type="select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.brandName}
                        invalid={
                          formik.touched.brandName && formik.errors.brandName
                            ? true
                            : false
                        }
                      >
                        <option value="" label="Select brand" />
                        {brandData.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.brand_sname}
                          </option>
                        ))}
                      </Input>
                      {formik.touched.brandName && formik.errors.brandName ? (
                        <FormFeedback type="invalid">
                          {formik.errors.brandName}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="card" style={{ border: "1px solid #e9ebec" }}>
                  <div className="card-header">
                    <h5 className="card-title">Feature Image</h5>
                  </div>
                  <div className="card-body">
                    <div>
                      <Input
                        name="images"
                        type="file"
                        accept="image/jpeg, image/png"
                        onChange={handleImageChange}
                        style={{ display: "none" }}
                        invalid={
                          formik.touched.images && formik.errors.images
                            ? true
                            : false
                        }
                      />
                      <div
                        className="custom-file-button"
                        onClick={() => toggleModal("feature")}
                      >
                        <i
                          className="bx bx-cloud-upload me-2"
                          style={{ fontSize: "25px" }}
                        ></i>
                        Choose File
                      </div>
                      {formik.touched.images && formik.errors.images ? (
                        <FormFeedback type="invalid" className="d-block">
                          {formik.errors.images}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div>
                      {uploadedImages.map((image, index) => (
                        <Card
                          className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                          key={index + "-file"}
                        >
                          <div className="p-2">
                            <Row className="align-items-center">
                              <Col className="col-auto mb-2">
                                <img
                                  src={imgurl + image.fileurl}
                                  alt="image_"
                                  className="w-100"
                                />
                              </Col>
                              <Col>
                                <Link
                                  to="#"
                                  className="text-muted font-weight-bold"
                                >
                                  {image.filename}
                                </Link>
                                <p className="mb-0">
                                  <strong>{image.filesize} KB</strong>
                                </p>
                              </Col>
                              <Col className="col-auto">
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    const newUploadedImages =
                                      uploadedImages.filter(
                                        (_, i) => i !== index
                                      );
                                    setUploadedImages(newUploadedImages);
                                    formik.setFieldValue(
                                      "images",
                                      newUploadedImages
                                    );
                                  }}
                                >
                                  Delete
                                </button>
                              </Col>
                            </Row>
                          </div>
                        </Card>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="card" style={{ border: "1px solid #e9ebec" }}>
                  <div className="card-header">
                    <h5 className="card-title">Other Images (Multiple)</h5>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                      <Input
                        name="otherImages"
                        type="file"
                        accept="image/jpeg, image/png"
                        onChange={handleOtherImageChange}
                        style={{ display: "none" }}
                        invalid={
                          formik.touched.otherImages &&
                          formik.errors.otherImages
                            ? true
                            : false
                        }
                      />
                      <div
                        className="custom-file-button"
                        onClick={() => toggleModal("other")}
                      >
                        <i
                          className="bx bx-cloud-upload me-2"
                          style={{ fontSize: "25px" }}
                        ></i>
                        Choose File
                      </div>
                      {formik.touched.otherImages &&
                      formik.errors.otherImages ? (
                        <FormFeedback type="invalid" className="d-block">
                          {formik.errors.otherImages}
                        </FormFeedback>
                      ) : null}
                    </div>

                    {uploadedOtherImages?.length > 0 && (
                      <>
                        <div
                          style={{
                            height: "500px",
                            overflowY: "auto",
                            overflowX: "hidden",
                          }}
                        >
                          {uploadedOtherImages.map((image, index) => (
                            <Card
                              className="mt-1 mb-3 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                              key={index + "-file"}
                            >
                              <div className="p-2">
                                <Row className="align-items-center">
                                  <Col className="col-auto mb-2">
                                    <img
                                      src={imgurl + image.fileurl}
                                      alt="image_"
                                      style={{
                                        maxWidth: "100%",
                                        height: "auto",
                                      }}
                                    />
                                  </Col>
                                  <Col>
                                    <Link
                                      to="#"
                                      className="text-muted font-weight-bold"
                                    >
                                     {image.filename}
                                    </Link>
                                    <p className="mb-0">
                                      <strong>{image.filesize} KB</strong>
                                    </p>
                                  </Col>
                                  <Col className="col-auto">
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm"
                                      onClick={() => {
                                        const newImages =
                                          uploadedOtherImages.filter(
                                            (_, i) => i !== index
                                          );
                                        setUploadedOtherImages(newImages);
                                      }}
                                    >
                                      Delete
                                    </button>
                                  </Col>
                                </Row>
                              </div>
                            </Card>
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="card" style={{ border: "1px solid #e9ebec" }}>
                  <div className="card-header">
                    <h5 className="card-title">Upload Datasheet</h5>
                  </div>
                  <div className="card-body">
                    <div>
                      <Input
                        name="technicalDataSheets"
                        type="file"
                        accept="application/pdf"
                        onChange={handleDataSheetChange}
                        style={{ display: "none" }}
                        invalid={
                          formik.touched.technicalDataSheets &&
                          formik.errors.technicalDataSheets
                            ? true
                            : false
                        }
                      />
                      <div
                        className="custom-file-button"
                        onClick={() => toggleModal("datasheet")}
                      >
                        <i
                          className="bx bx-cloud-upload me-2"
                          style={{ fontSize: "25px" }}
                        ></i>
                        Choose Datasheet
                      </div>
                      {formik.touched.technicalDataSheets &&
                      formik.errors.technicalDataSheets ? (
                        <FormFeedback type="invalid" className="d-block">
                          {formik.errors.technicalDataSheets}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div>
                      {pdfPreviewUrl && (
                        <Col className="col-12 mt-3">
                          <Label className="form-label">
                            Uploaded Datasheet
                          </Label>
                          <div className="mb-3">
                            <Button
                              color="primary"
                              onClick={() =>
                                window.open(pdfPreviewUrl, "_blank")
                              }
                            >
                              View
                            </Button>
                            <Button
                              color="danger"
                              onClick={handleRemovePdf}
                              className="ms-3"
                            >
                              Delete
                            </Button>
                          </div>
                        </Col>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Row>
              <Col>
                <div className="text-end mb-3">
                  <Button type="submit" color="success">
                    Update
                  </Button>
                </div>
              </Col>
            </Row>
          </form>

          {/* Model for upload image */}
          <MediaModel
            imageModel={imageModel}
            toggleModal={toggleModal}
            handleUploadImage={handleUploadImage}
            selectedImage={selectedImage}
            setSelectedImage={setSelectedImage}
            modalType={modalType}
          />
        </Container>
      </div>
    </>
  );
};

export default withRouter(EditProduct);
